import script from "./SocialMediaEnricherView.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialMediaEnricherView.vue?vue&type=script&setup=true&lang=js"

import "./SocialMediaEnricherView.vue?vue&type=style&index=0&id=6f5d17e0&lang=scss"

const __exports__ = script;

export default __exports__